exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body.overflow-auto[data-v-2a055a5d]{overflow:auto}.pagination[data-v-2a055a5d]{display:inline-block!important}", ""]);

// exports
